import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default class ProductGrid {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;
    this.carouselEl = this.el.querySelector('.swiper');
    this.currentSlideText = this.el.querySelector('.current-slide');

    this.init();
  }

  init() {
    if (this.carouselEl) {
      this.carousel = new Swiper(this.carouselEl, {
        loop: false,
        slidesPerView: 1.5,
        spaceBetween: 12.5,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 12.5,
          },
        },
        on: {
          slideChange: () => {
            if (this.currentSlideText) {
              this.currentSlideText.innerHTML = this.carousel?.realIndex + 1;
            }
          },
        },
      });

      this.prev = this.el.querySelector('.prev');
      this.next = this.el.querySelector('.next');

      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.carousel.slidePrev();
        });
      }

      if (this.next) {
        this.next.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }
    }
  }
}
